/**
 * PWA replacement for `src/shared/config/environment`.
 * Driven by `generatedClient.ts` (written by applyPwaClient) so `--index N` can
 * target a different white-label than the native applications.ts INDEX.
 */
import { generated_pwa_client } from './generatedClient';

export interface Environment {
  production: boolean;
  API_URL: string;
  APP_VERSION: string;
  APP_ID: string;
  APP_NAME: string;
  IDENTIFIER: string;
  LOGIN_PAGE: string;
  IS_INTERNAL: boolean;
}

function resolveApiUrl(identifier: string): string {
  if (identifier === 'lofat' || identifier === 'ghadhana') {
    return 'https://foodna.dietmaster.fit/api/customer/';
  }
  return 'https://console.dietmaster.fit/api/customer/';
}

const identifier = generated_pwa_client.identifier || 'testing';

export const environment: Environment = {
  production: !__DEV__,
  API_URL: resolveApiUrl(identifier),
  APP_VERSION: String(generated_pwa_client.versionAndroid ?? generated_pwa_client.versionIos ?? '1.0.0'),
  APP_ID: generated_pwa_client.appId || '',
  APP_NAME: generated_pwa_client.appName || 'Diet Fit',
  IDENTIFIER: identifier,
  LOGIN_PAGE: 'onboarding',
  IS_INTERNAL: identifier === 'testing',
};

export default environment;
